/* eslint-disable no-case-declarations,camelcase */

import {DATA_INTEGRATION_JOBS_STATUSES} from '../../const';

const ACTIONS_TYPES = {
  SET_CONNECTIONS: 'SET_CONNECTIONS',
  UPDATE_CONNECTION: 'UPDATE_CONNECTION',
  UPDATE_CONNECTION_SUCCESS: 'UPDATE_CONNECTION_SUCCESS',
  UPDATE_CONNECTION_FAIL: 'UPDATE_CONNECTION_FAIL',
  DELETE_CONNECTION: 'DELETE_CONNECTION',
  DELETE_CONNECTION_SUCCESS: 'DELETE_CONNECTION_SUCCESS',
  DELETE_CONNECTION_FAIL: 'DELETE_CONNECTION_FAIL',
  REFRESH_CONNECTION: 'REFRESH_CONNECTION',
  REFRESH_CONNECTION_SUCCESS: 'REFRESH_CONNECTION_SUCCESS',
  // Folders integration relative jobs
  JOB_REGISTERED: 'JOB_REGISTERED',
  JOB_POLLED: 'JOB_POLLED',
  JOB_HANDLED: 'JOB_HANDLED',
  // State relative to project users
  SET_EMAIL_ERROR: 'SET_EMAIL_ERROR',
  SET_IS_SUBMITTING: 'SET_IS_SUBMITTING',
  DELETE_USER: 'DELETE_USER',
  SET_DELETE_USER_SUCCESS: 'SET_DELETE_USER_SUCCESS',
  ADD_USER: 'ADD_USER',
  SET_ADD_USER_SUCCESS: 'SET_ADD_USER_SUCCESS',
  INVITE_USER_SUCCESS: 'INVITE_USER_SUCCESS',
  TOGGLE_DELETE_USER_MODAL: 'TOGGLE_DELETE_USER_MODAL',
  SET_USER_TO_DELETE: 'SET_USER_TO_DELETE',
  TOGGLE_PROMOTE_USER_MODAL: 'TOGGLE_PROMOTE_USER_MODAL',
  SET_USER_TO_PROMOTE: 'SET_USER_TO_PROMOTE',
  PROMOTE_OR_DEMOTE_SUCCESS: 'PROMOTE_OR_DEMOTE_SUCCESS'
};

const ActionCreators = dispatch => ({
  setConnections: connections => {
    dispatch({type: ACTIONS_TYPES.SET_CONNECTIONS, payload: connections});
  },
  updateConnection: conn => {
    dispatch({type: ACTIONS_TYPES.UPDATE_CONNECTION, payload: conn});
  },
  updateConnectionSuccess: conn => {
    dispatch({type: ACTIONS_TYPES.UPDATE_CONNECTION_SUCCESS, payload: conn});
  },
  updateConnectionFail: conn => {
    dispatch({type: ACTIONS_TYPES.UPDATE_CONNECTION_FAIL, payload: conn});
  },
  deleteConnection: conn => {
    dispatch({type: ACTIONS_TYPES.DELETE_CONNECTION, payload: conn});
  },
  deleteConnectionSuccess: conn => {
    dispatch({type: ACTIONS_TYPES.DELETE_CONNECTION_SUCCESS, payload: conn});
  },
  deleteConnectionFail: conn => {
    dispatch({type: ACTIONS_TYPES.DELETE_CONNECTION_FAIL, payload: conn});
  },

  refreshConnection: conn => {
    dispatch({type: ACTIONS_TYPES.REFRESH_CONNECTION, payload: conn});
  },
  refreshConnectionSuccess: conn => {
    dispatch({type: ACTIONS_TYPES.REFRESH_CONNECTION_SUCCESS, payload: conn});
  },

  jobRegistered: job => {
    dispatch({
      type: ACTIONS_TYPES.JOB_REGISTERED,
      payload: job
    });
  },

  jobPolled: pollData => {
    dispatch({
      type: ACTIONS_TYPES.JOB_POLLED,
      payload: pollData
    });
  },

  jobHandled: jobId => {
    dispatch({
      type: ACTIONS_TYPES.JOB_HANDLED,
      payload: jobId
    });
  },

  // State relative to project users
  setEmailError: errorText => {
    dispatch({type: ACTIONS_TYPES.SET_EMAIL_ERROR, payload: errorText});
  },
  setIsSubmitting: submitting => {
    dispatch({type: ACTIONS_TYPES.SET_IS_SUBMITTING, payload: submitting});
  },
  deleteUser: () => {
    dispatch({type: ACTIONS_TYPES.DELETE_USER});
  },
  setDeletedSuccessfully: ({siren, schema, userId}) => {
    dispatch({type: ACTIONS_TYPES.SET_DELETE_USER_SUCCESS, payload: {siren, schema, userId}});
  },
  addUser: () => {
    dispatch({type: ACTIONS_TYPES.ADD_USER});
  },
  setAddedSuccessfully: ({siren, schema, user}) => {
    dispatch({type: ACTIONS_TYPES.SET_ADD_USER_SUCCESS, payload: {siren, schema, user}});
  },
  setUserInvitedSuccessMessage: message => {
    dispatch({type: ACTIONS_TYPES.INVITE_USER_SUCCESS, payload: message});
  },
  setDeleteUserModalOpen: isOpen => {
    dispatch({type: ACTIONS_TYPES.TOGGLE_DELETE_USER_MODAL, payload: isOpen});
  },
  setUserToDelete: userId => {
    dispatch({type: ACTIONS_TYPES.SET_USER_TO_DELETE, payload: userId});
  },
  setPromoteModalOpen: isOpen => {
    dispatch({type: ACTIONS_TYPES.TOGGLE_PROMOTE_USER_MODAL, payload: isOpen});
  },
  setUserToPromote: userId => {
    dispatch({type: ACTIONS_TYPES.SET_USER_TO_PROMOTE, payload: userId});
  },
  promoteOrDemoteUser: ({siren, schema, userId}) => {
    dispatch({type: ACTIONS_TYPES.PROMOTE_OR_DEMOTE_SUCCESS, payload: {siren, schema, userId}});
  }
});

const initialState = {
  integrationJobs: {},
  projects: [],
  deleting: [],
  updating: [],
  refreshing: [],
  // State relative to project users
  emailError: '',
  isSubmitting: false,
  userInvitedSuccessMessage: '',
  deleteUserModalOpen: false,
  userToDelete: null,
  promoteModalOpen: false,
  userToPromote: null
};

// eslint-disable-next-line default-param-last,complexity
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS_TYPES.SET_CONNECTIONS:
      return {...state, projects: action.payload};

    case ACTIONS_TYPES.UPDATE_CONNECTION:
      return {
        ...state,
        updating: [...state.updating, action.payload.siren + action.payload.schema_name]
      };

    case ACTIONS_TYPES.UPDATE_CONNECTION_SUCCESS:
      return {
        ...state,
        projects: state.projects.map(project => (project.siren === action.payload.siren && project.schema_name === action.payload.schema_name ? {...project, ...action.payload} : project)),
        updating: state.updating.filter(id => id !== action.payload.siren + action.payload.schema_name)
      };

    case ACTIONS_TYPES.UPDATE_CONNECTION_FAIL:
      return {
        ...state,
        updating: state.updating.filter(id => id !== action.payload.siren + action.payload.schema_name)
      };

    case ACTIONS_TYPES.DELETE_CONNECTION:
      return {
        ...state,
        deleting: [...state.deleting, action.payload.siren + action.payload.schema_name]
      };

    case ACTIONS_TYPES.DELETE_CONNECTION_SUCCESS:
      return {
        ...state,
        projects: state.projects.filter(project => {
          return !(project.siren === action.payload.siren && project.schema_name === action.payload.schema_name);
        }),
        deleting: state.deleting.filter(id => id !== action.payload.siren + action.payload.schema_name)
      };

    case ACTIONS_TYPES.DELETE_CONNECTION_FAIL:
      return {
        ...state,
        deleting: state.deleting.filter(id => id !== action.payload.siren + action.payload.schema_name)
      };

    case ACTIONS_TYPES.REFRESH_CONNECTION:
      return {
        ...state,
        refreshing: [...state.refreshing, action.payload.siren + action.payload.schema_name]
      };

    case ACTIONS_TYPES.REFRESH_CONNECTION_SUCCESS:
      return {
        ...state,
        refreshing: state.refreshing.filter(id => id !== action.payload.siren + action.payload.schema_name)
      };

    case ACTIONS_TYPES.JOB_REGISTERED: {
      const {job_id} = action.payload;

      return {
        ...state,
        integrationJobs: {
          ...state.integrationJobs,
          [job_id]: {
            ...action.payload,
            status: DATA_INTEGRATION_JOBS_STATUSES.REGISTERED,
            completedCount: 0,
            totalCount: 0,
            results: null,
            handled: false,
            lastPollData: null
          }
        }
      };
    }

    case ACTIONS_TYPES.JOB_POLLED: {
      const {job_id, runtimeStatus, completed_count = 0, total_companies = 0, results} = action.payload;

      const job = state.integrationJobs[job_id];
      if (!job) return state;

      return {
        ...state,
        integrationJobs: {
          ...state.integrationJobs,
          [job_id]: {
            ...job,
            status: runtimeStatus,
            completedCount: completed_count,
            totalCount: total_companies,
            results: results ?? job.results,
            lastPollData: action.payload
          }
        }
      };
    }

    case ACTIONS_TYPES.JOB_HANDLED: {
      const jobId = action.payload;

      return {
        ...state,
        integrationJobs: {
          ...state.integrationJobs,
          [jobId]: {
            ...state.integrationJobs[jobId],
            handled: true
          }
        }
      };
    }

    case ACTIONS_TYPES.SET_EMAIL_ERROR:
      return {...state, emailError: action.payload};
    case ACTIONS_TYPES.SET_IS_SUBMITTING:
      return {...state, isSubmitting: action.payload};

    case ACTIONS_TYPES.DELETE_USER:
      return {
        ...state,
        isSubmitting: true,
        deleteUserModalOpen: false,
        userInvitedSuccessMessage: ''
      };
    case ACTIONS_TYPES.SET_DELETE_USER_SUCCESS: {
      const {siren, schema, userId} = action.payload;

      return {
        ...state,
        isSubmitting: false,
        projects: state.projects.map(p =>
          p.siren === siren && p.schema_name === schema
            ? {
                ...p,
                users: p.users.filter(user => user.user_id !== userId)
              }
            : p
        )
      };
    }
    case ACTIONS_TYPES.ADD_USER:
      return {
        ...state,
        isSubmitting: true,
        userInvitedSuccessMessage: ''
      };

    case ACTIONS_TYPES.SET_ADD_USER_SUCCESS: {
      const {siren, schema, user} = action.payload;

      return {
        ...state,
        isSubmitting: false,
        projects: state.projects.map(p =>
          p.siren === siren && p.schema_name === schema
            ? {
                ...p,
                users: [...p.users, user]
              }
            : p
        )
      };
    }

    case ACTIONS_TYPES.PROMOTE_OR_DEMOTE_SUCCESS: {
      const {siren, schema, userId} = action.payload;
      return {
        ...state,
        isSubmitting: false,
        projects: state.projects.map(p =>
          p.siren === siren && p.schema_name === schema
            ? {
                ...p,
                users: p.users.map(u => (u.user_id === userId ? {...u, is_owner: !u.is_owner} : u))
              }
            : p
        )
      };
    }

    case ACTIONS_TYPES.INVITE_USER_SUCCESS:
      return {...state, userInvitedSuccessMessage: action.payload};
    case ACTIONS_TYPES.TOGGLE_DELETE_USER_MODAL:
      return {...state, deleteUserModalOpen: action.payload};
    case ACTIONS_TYPES.SET_USER_TO_DELETE:
      return {...state, userToDelete: action.payload};
    case ACTIONS_TYPES.TOGGLE_PROMOTE_USER_MODAL:
      return {...state, promoteModalOpen: action.payload};
    case ACTIONS_TYPES.SET_USER_TO_PROMOTE:
      return {...state, userToPromote: action.payload};
    default:
      throw new Error(`Action type ${action.type} doesn't exist`);
  }
};

export {reducer, initialState, ActionCreators};
